export const RENTAL_FILES = {
    COLLECTION: {
        url: '/remoteCollections/:remoteCollectionsId/rentalFiles',
        queryKey: 'getRentalFiles'
    },
    DETAILS: {
        url: '/rentalFiles/:rentalFileId',
        queryKey: 'getRentalFile'
    }
};